class AqualizaCarouselControls extends HTMLElement {
  connectedCallback() {
    this.carousel = this.closest('.resource-list__carousel');
    this.slideshow = this.carousel?.querySelector('slideshow-component');
    this.scroller = this.slideshow?.querySelector('slideshow-slides');
    this.prevButton = this.querySelector('[data-aq-carousel-prev]');
    this.nextButton = this.querySelector('[data-aq-carousel-next]');

    if (!this.slideshow || !this.scroller || !this.prevButton || !this.nextButton) {
      this.hidden = true;
      return;
    }

    this.onPrevious = (event) => {
      event.preventDefault();
      event.stopPropagation();
      this.slideshow.previous(event);
      window.setTimeout(() => this.update(), 250);
    };

    this.onNext = (event) => {
      event.preventDefault();
      event.stopPropagation();
      this.slideshow.next(event);
      window.setTimeout(() => this.update(), 250);
    };

    this.update = this.update.bind(this);
    this.prevButton.addEventListener('click', this.onPrevious);
    this.nextButton.addEventListener('click', this.onNext);
    this.scroller.addEventListener('scroll', this.update, { passive: true });
    window.addEventListener('resize', this.update, { passive: true });

    this.resizeObserver = new ResizeObserver(this.update);
    this.resizeObserver.observe(this.scroller);

    requestAnimationFrame(() => this.update());
    window.setTimeout(() => this.update(), 500);
  }

  disconnectedCallback() {
    this.prevButton?.removeEventListener('click', this.onPrevious);
    this.nextButton?.removeEventListener('click', this.onNext);
    this.scroller?.removeEventListener('scroll', this.update);
    window.removeEventListener('resize', this.update);
    this.resizeObserver?.disconnect();
  }

  update() {
    if (!this.scroller) return;

    const maxScroll = Math.max(0, this.scroller.scrollWidth - this.scroller.clientWidth);
    const left = Math.abs(this.scroller.scrollLeft);
    const hasOverflow = maxScroll > 4;

    this.hidden = !hasOverflow;
    this.prevButton.disabled = !hasOverflow || left <= 4;
    this.nextButton.disabled = !hasOverflow || left >= maxScroll - 4;
  }
}

if (!customElements.get('aqualiza-carousel-controls')) {
  customElements.define('aqualiza-carousel-controls', AqualizaCarouselControls);
}
